import VisaCard from "./Visa/Visa"
import MasterCard from "./MasterCard/MasterCard"
import AmexCard from "./Amex/Amex"
import CreditCard from "./CreditCard/CreditCard"

const Cards = ({type = 'visa', size = 48, color}) => {
    if(type === 'visa'){
        return <VisaCard size={size} color={color} />
    }

    if(type === 'mastercard'){
        return <MasterCard size={size} color={color} />
    }

    if(type === 'amex'){
        return <AmexCard size={size} color={color} />
    }

    return <CreditCard size={size} color={color} />
}

export default Cards;